// ==================== 维度与时间 ====================
export type DashboardDimension = 'MONTH' | 'YEAR';
export enum TrendGranularity {
  HOUR = 'H',
  DAY = 'D',
  MONTH = 'M',
}
export type DataType = 'INSTANT' | 'ACCUMULATION' | 'BOTH';
export type DeviceType = 'GAS' | 'WATER';
export type TrendType = 'VOCS' | 'ACCUMULATION';

// ==================== 设备信息 ====================
export interface DeviceItem {
  id: number;
  deviceId: number;
  name: string;
  code?: string;
}

// ==================== 组件 Props ====================
export interface DimensionSelectorProps {
  dimension: DashboardDimension;
  timeValue: string;
  onDimensionChange: (dimension: DashboardDimension) => void;
  onTimeChange: (time: string) => void;
  onRefresh: () => void;
}

export interface EmissionOverviewProps {
  dimension: DashboardDimension;
  timeValue: string;
  refreshKey: number;
}

export interface IndicatorCardsProps {
  refreshKey: number;
}

export interface TrendChartProps {
  refreshKey: number;
}

export interface OverallWaterChartProps {
  refreshKey: number;
}

export interface DeviceDetailProps {
  deviceType: DeviceType;
  devices: DeviceItem[];
  refreshKey: number;
}
